import store from '../../store/configureStore';
import PolygonLookup from 'polygon-lookup';

export default class MapProperties {
  center = {
    lat: 12.91576353654974,
    lng: 77.57960150687137
  };
  zoom = 14.5;
  view = {
    center: {
      lat: 12.91576353654974,
      lng: 77.57960150687137
    },
    zoom: 14.5,
    bounds: {
      _northEast: {
        lat: 12.942413392578684,
        lng: 77.62278556823732
      },
      _southWest: {
        lat: 12.8891225175057,
        lng: 77.53635406494142
      }
    },
  };
  features = new Map();
  marker_register = new Map();
  constructor(initializer = {}) {
    Object.assign(this, initializer);
  }
  addFeature(key, feature) {
    if(this.features.has(key)) {
    } else {
      this.features.set(key, feature);
    }
  }
  static get ACTIONS() {
    return {
      SET_CENTER: 'SET_CENTER',
      ADD_FEATURES: 'ADD_FEATURES',
      ADD_MARKERS: 'ADD_MARKERS',
    };
  }
  updateView(view) {
    this.oldView = Object.assign({},
      this.oldView, this.view);
    this.view = Object.assign({},
      this.view, view);
  }
  setView(center, zoom, radius, bounds) {
    store.dispatch ({
      type: MapProperties.ACTIONS.SET_CENTER,
      view: {
        center: center,
        zoom: zoom,
        radius: radius,
        bounds: bounds
      }
    });
  }
  addMarkers(markers, component_key) {
    let marker_register = Object.assign({}, this.marker_register, {
      [component_key]: markers
    });
    Object.assign(this, {
      marker_register
    });
  }
  static addMarkers(markers, component_key) {
    store.dispatch({
      type: MapProperties.ACTIONS.ADD_MARKERS,
      markers,
      component_key
    });
  }
  static reducer(state = {}, action) {
    switch(action.type) {
      case MapProperties.ACTIONS.SET_CENTER: {
        let mapProperties = new MapProperties(state);
        mapProperties.updateView(action.view);
        return (mapProperties);
      }
      case MapProperties.ACTIONS.ADD_FEATURES: {
        let newState = new MapProperties(state);
        if((action.data)&&(action.data.count)&&(action.data.count > 1)) {
          action.data.features.map((feature, index) => {
            newState.addFeature(action.uids[index], feature);
          });
        }
        return newState;
      }
      case MapProperties.ACTIONS.ADD_MARKERS: {
        let newState = new MapProperties(state);
        newState.addMarkers(action.markers, action.component_key);
        return newState;
      }
      default: {
        return state;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/map/Properties.js